import { publicEnv, publicInteger } from "./runtimeEnv";

const lower = (value) => value ? value.toLowerCase() : "";
const makeNetwork = (
  prefix,
  build,
  fallbackChainId,
  currencySymbol,
  liveName,
  testName,
  blockExplorerUrl,
) => {
  const chainIdName = `REACT_APP_${prefix}_CHAIN_ID`;
  const chainId = publicInteger(chainIdName, build.chainId, fallbackChainId);
  const rpcUrl = publicEnv(`REACT_APP_${prefix}_RPC_URL`, build.rpcUrl);
  const name = chainId === fallbackChainId ? liveName : testName;

  return {
    currencySymbol,
    TradeContract: lower(publicEnv(
      `REACT_APP_${prefix}_TRADE_CONTRACT`,
      build.tradeContract,
    )),
    singleContract: lower(publicEnv(
      `REACT_APP_${prefix}_SINGLE_CONTRACT`,
      build.singleContract,
    )),
    multipleContract: lower(publicEnv(
      `REACT_APP_${prefix}_MULTIPLE_CONTRACT`,
      build.multipleContract,
    )),
    literatureContract: lower(publicEnv(
      `REACT_APP_${prefix}_LITERATURE_CONTRACT`,
      build.literatureContract,
    )),
    exchangeAddress: lower(publicEnv(
      `REACT_APP_${prefix}_EXCHANGE_ADDRESS`,
      build.exchangeAddress,
    )),
    adminAddress: lower(publicEnv(
      `REACT_APP_${prefix}_ADMIN_ADDRESS`,
      build.adminAddress,
    )),
    BNBPROVIDER: rpcUrl,
    rpcUrls: rpcUrl ? [rpcUrl] : [],
    chainName: name,
    nativeCurrency: {
      name: currencySymbol === "ETH" ? "Ether" : "BNB",
      symbol: currencySymbol,
      decimals: 18,
    },
    blockExplorerUrls: blockExplorerUrl ? [blockExplorerUrl] : [],
    networkVersion: String(chainId),
    chainId: `0x${chainId.toString(16)}`,
    Chainid: chainId,
    name,
    trade: lower(publicEnv(
      `REACT_APP_${prefix}_TRADE_CONTRACT`,
      build.tradeContract,
    )),
  };
};

const network = {
  ETH: makeNetwork("ETH", {
    chainId: process.env.REACT_APP_ETH_CHAIN_ID,
    tradeContract: process.env.REACT_APP_ETH_TRADE_CONTRACT,
    singleContract: process.env.REACT_APP_ETH_SINGLE_CONTRACT,
    multipleContract: process.env.REACT_APP_ETH_MULTIPLE_CONTRACT,
    literatureContract: process.env.REACT_APP_ETH_LITERATURE_CONTRACT,
    exchangeAddress: process.env.REACT_APP_ETH_EXCHANGE_ADDRESS,
    adminAddress: process.env.REACT_APP_ETH_ADMIN_ADDRESS,
    rpcUrl: process.env.REACT_APP_ETH_RPC_URL,
  }, 1, "ETH", "Ethereum", "Ethereum Testnet", "https://etherscan.io"),
  BSC: makeNetwork("BSC", {
    chainId: process.env.REACT_APP_BSC_CHAIN_ID,
    tradeContract: process.env.REACT_APP_BSC_TRADE_CONTRACT,
    singleContract: process.env.REACT_APP_BSC_SINGLE_CONTRACT,
    multipleContract: process.env.REACT_APP_BSC_MULTIPLE_CONTRACT,
    literatureContract: process.env.REACT_APP_BSC_LITERATURE_CONTRACT,
    exchangeAddress: process.env.REACT_APP_BSC_EXCHANGE_ADDRESS,
    adminAddress: process.env.REACT_APP_BSC_ADMIN_ADDRESS,
    rpcUrl: process.env.REACT_APP_BSC_RPC_URL,
  }, 56, "BNB", "BNB Smart Chain", "BSC Testnet", "https://bscscan.com"),
};

export default network;
